
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    max: {
      type: Number,
      default: 6,
    },
    radio: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      weeks: this.value,
    };
  },
  computed: {
    weekNrs() {
      const weeks = [];
      let date = this.$moment();

      for (let i = 0; i < this.max; i++) {
        weeks.push({
          week: date.week(),
          year: date.year(),
        });

        date = date.clone().add(1, 'week');
      }

      return weeks;
    },
  },
  watch: {
    weeks() {
      if (!this.radio) {
        this.$emit('input', this.weeks);
      }
    },
  },
  methods: {
    selectWeek(week) {
      if (this.radio) {
        this.weeks = [week];

        this.$emit('input', this.weeks);
      }
    },
  },
};
